import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    selectedYear: null,
    selectedRegion: null,
    selectedSupplier: null,
  },
  loading: false,
}

export const annualCapacitySlice = createAppSlice({
  name: 'annualCapacity',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
  }),
})

export const { setFetchOption, setLoading } = annualCapacitySlice.actions

export default annualCapacitySlice.reducer
